// src/api/routes.js
// Single source of truth for all API resource paths.
// Import from here instead of using string literals inline.

export const ROUTES = {
  // Config
  connections: "integrations/cfg/connections",
  fileTransfers: "integrations/cfg/transfers",
  fileTransferCmds: (transferID) =>
    `integrations/cfg/transfer/${transferID}/cmds`,
  connectionCmds: (connectionID) =>
    `integrations/cfg/connection/${connectionID}/cmds`,
  apiConfigs: "integrations/cfg/apiconfigs",
  serviceConfigs: "integrations/cfg/serviceconfigs",
  schedules: "integrations/cfg/schedules",
  scheduleTasks: (scheduleId) =>
    `integrations/cfg/schedule/${scheduleId}/tasks`,
  queryInfo: "integrations/cfg/query/info",

  // File Transfer Stats & History
  fileTransferHistory: "integrations/cfg/transfers/daily",
  fileTransferStatsByTransfer: "integrations/cfg/transfers/count",
  fileTransferStatsByProject: "integrations/cfg/transfers/project",
  fileTransferStatsByGroup: "integrations/cfg/transfers/group",

  // ESB / Error Log
  errorLogCount: "integrations/esb/errorlog/count",
  errorLogEvents: "integrations/esb/errorlog/events",
  errorLogEventFile: (pkError) =>
    `integrations/esb/errorlog/events/${pkError}`,
  errorLogBySourceEntity: (source, entity) =>
    `integrations/esb/errorlog/source/${source}/entity/${entity}`,
  eventsCount: "integrations/esb/events/count",
  receiveDataCount: "integrations/esb/receivedata/count",
  cache: {
    list: "integrations/esb/cache/list",
    clear: (cacheName) => `integrations/esb/cache/${cacheName}`,
  },
  kickouts: {
    bySourceEntity: (source, entity) =>
      `integrations/esb/kickouts/source/${source}/entity/${entity}`,
    eventFile: (eventId) =>
      `integrations/eds/event/kickout/${eventId}`,
  },

  // EDS / Monitoring
  unifiedEventSummary: "integrations/eds/monitor/unified",
  unifiedFileSummary: "integrations/eds/monitor/files",
  batchProcessSummary: "integrations/eds/monitor/batch",
  jobRunHistory: "integrations/eds/monitor/jobruns",
  remoteExec: "integrations/eds/remoteexec?daysFromToday=28",
  remoteScripts: "integrations/eds/remotescripts",

  // Remarque
  remarqueLastGetEvents: "integrations/remarque/lastgetevents",

  // Oura / Incyte
  ouraOnboard: "incyte/oura/onboard",

  // RMQ API uploads
  rmqApiUploads: "integrations/rmq/api/uploads",
};
